<template>
    <v-card  class="pb-80 event-details" elevation=0 >
            <v-system-bar
                flat
                color="transparent"
                fixed
                height="40"
                class="pt-3">




                <v-btn href="food" fab small color="primary" >
                    <v-icon class="white--text ">mdi-arrow-left</v-icon>
                </v-btn>

            </v-system-bar>
            <v-card-title >

            <div class="headline font-weight-bold mt-5 pt-5">Your Favorites</div>
            <!-- <v-row align="center">
                <v-col cols="12">
                    <v-text-field name="search"  class="srch" label="Search" prepend-inner-icon="mdi-magnify" filled dense></v-text-field>
                </v-col>
            </v-row> -->
            </v-card-title>
            <v-card-text class="mb-auto">

               <v-row align="center">
                        <v-col cols="12" v-for="(item,ind) in order.items" :key="ind" class="pa-2">



                                <v-card tile class="" outlined >
                                    <v-row>

                                        <v-col cols="3" class="pb-0">
                                                <v-icon class="close-icon" @click="deleteorderitem(ind)">mdi-close</v-icon>

                                            <v-avatar
                                                class=""
                                                size="80"
                                                tile
                                            >

                                            <v-img :src="item.image" >

                                            </v-img>
                                            </v-avatar>
                                        </v-col>
                                        <v-col cols="9" class="">


                                            <v-row>
                                                <v-col cols="12 pt-0">
                                                    <h3>{{item.title}}</h3>
                                                    <p style="font-size:16px;">{{item.subtitle}}</p>
                                                    <p style="font-size:14px;">{{item.course}}</p>


                                                </v-col>


                                                <!-- <v-col cols="12" class="text-right pr-5 pb-0 pt-0">


                                                        <span style="font-size:16px" >{{item.qty}}IT </span><br>
                                                        <span class="subtitle" style="font-weight:bold;color:#FE5800">{{item.total}} <i :class="'fa '+business.currencydata.icon" aria-hidden="true"></i></span>

                                                </v-col> -->
                                            </v-row>


                                        </v-col>
                                    </v-row>





                                </v-card>


                        </v-col>
                </v-row>
                <!-- <v-divider></v-divider>
                <v-row align="center">
                  <v-col cols="5"><strong class="subtitle">Total</strong></v-col>
                  <v-col class="text-center subtitle">{{itemqty}}IT</v-col>
                  <v-col class="text-right "><strong class="subtitle">{{ordertotal.toFixed(2)}} <i :class="'fa '+business.currencydata.icon" aria-hidden="true"></i></strong></v-col>
                </v-row> -->
                <!-- <v-row>
                  <v-col cols="12">
                    <v-btn block color="primary">Order</v-btn>
                  </v-col>
                </v-row> -->
            </v-card-text>
    </v-card>
</template>
<script>
import Vue from 'vue'
import { EventBus } from '@/event-bus';


    export default {
        props:['order','business'],
        data: () =>
        ({
          ordertotal:0,
          itemqty:0,
          currentorder:[],
          fooditemid:0,
        }),
        created(){
          this.calculatetotals();
        },

        watch:{
            order:function(value)
            {
                return value;
            },

        },
        methods:
        {

            calculatetotals()
            {
              let th=this;
              let ordertotal=0;
              let itemqty=0;
              let itemid=0;
                this.order.items.forEach(function(item){
                    ordertotal=ordertotal+item.total;
                    itemqty=itemqty+item.qty;
                    itemid=item.itemid;
                });
              this.ordertotal=ordertotal;
              this.itemqty=itemqty;
              this.fooditemid=itemid;

              
            },

          deleteorderitem(ind){
           this.order.items.splice(ind,1);
            
            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            // this.$http
            //   .get(this.$apidomain+"itemorderedupdate/"+this.fooditemid+'/'+delitem.qty+'/minus')
            //   .then(res => {
              
            //    })
            //   .catch(err => {
            //     console.log(err.response);
            //   });

            this.calculatetotals();


          },

        }
    }
</script>
<style scoped>
  .close-icon{
    position:absolute;
    top:15pxs;
    right:15px;
    width: 24px;
    height: 24px;
    z-index: 9999;
    font-size: 20px;
}
</style>
